import { InputRow } from './input-row'
import { InputsContainer } from './inputs-container'
import { InfoBoxRow } from './info-box-row'
import { InputColumns, InputColumn } from './input-columns'

export * from './types'

export const InputSection = {
  Row: InputRow,
  Container: InputsContainer,
  InfoBox: InfoBoxRow,
  Columns: InputColumns,
  Column: InputColumn
}
